import { render, staticRenderFns } from "./information-notice.vue?vue&type=template&id=61c0a350&scoped=true"
import script from "./information-notice.vue?vue&type=script&lang=js"
export * from "./information-notice.vue?vue&type=script&lang=js"
import style0 from "./information-notice.vue?vue&type=style&index=0&id=61c0a350&prod&lang=less&scoped=true"
import style1 from "./information-notice.vue?vue&type=style&index=1&id=61c0a350&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c0a350",
  null
  
)

export default component.exports